import { faCat, faComment, faDog, faEnvelope, faHorse } from "@fortawesome/pro-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { FrequencyUnit, PatientKind } from "common/types";

import { DeliveryMethod } from "./types";

export const SPECIES_ICONS: Partial<Record<PatientKind, IconDefinition>> = {
  [PatientKind.Canine]: faDog,
  [PatientKind.Feline]: faCat,
  [PatientKind.Equine]: faHorse,
};

export const INTERVAL_LABELS: Record<FrequencyUnit, string> = {
  [FrequencyUnit.Day]: "Days",
  [FrequencyUnit.Week]: "Weeks",
  [FrequencyUnit.Month]: "Months",
  [FrequencyUnit.Year]: "Years",
};

export const SINGULAR_INTERVAL_LABELS: Record<FrequencyUnit, string> = {
  [FrequencyUnit.Day]: "Day",
  [FrequencyUnit.Week]: "Week",
  [FrequencyUnit.Month]: "Month",
  [FrequencyUnit.Year]: "Year",
};

export const INTERVAL_LABEL_DISPLAY: Record<FrequencyUnit, string> = {
  [FrequencyUnit.Day]: "Daily",
  [FrequencyUnit.Week]: "Weekly",
  [FrequencyUnit.Month]: "Monthly",
  [FrequencyUnit.Year]: "Yearly",
};

export const DELIVERY_METHOD_OPTIONS: {
  value: DeliveryMethod;
  label: string;
  icon: IconDefinition;
}[] = [
  { value: "text", label: "Text", icon: faComment },
  { value: "email", label: "Email", icon: faEnvelope },
];
